export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.3-1547.29",
  commitId: "4afe249bc994d7b9e61237c891186af7d07a70f2",
  commitTime: "2026-08-03T15:47:29.000Z",
});
